import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPage from "../pages/privacy/page";
import DataDeletionPage from "../pages/data-deletion/page";
import TermsPage from "../pages/terms/page";
import CriarPage from "../pages/criar/page";
import CriarMusicaPage from "../pages/criar-musica/page";
import CriarMusicaOrderPage from "../pages/criar-musica/OrderPage";
import CriarMusicaCheckoutPage from "../pages/criar-musica/CheckoutPage";
import CriarMusicaSuccessPage from "../pages/criar-musica/SuccessPage";
import CriarMusicaPhotosPage from "../pages/criar-musica/PhotosPage";
import CriarMusicaLyricsPage from "../pages/criar-musica/LyricsPage";
import CriarMusicaRecordingPage from "../pages/criar-musica/RecordingPage";
import CriarMusicaPreviewPage from "../pages/criar-musica/PreviewPage";
import OuvirPage from "../pages/ouvir/page";
import OuvirSlugPage from "../pages/ouvir/SlugPage";
import ObrigadoPage from "../pages/obrigado/page";
import BlogPage from "../pages/blog/page";
import PostPage from "../pages/blog/PostPage";
import FAQPage from "../pages/faq/page";
import MusicaPersonalizadaPage from "../pages/musica-personalizada/page";
import AfiliadosPage from "../pages/afiliados/page";
import AfiliadoPortalPage from "../pages/afiliados/portal";
import AfiliadosTermosPage from "../pages/afiliados/termos";
import GerarLink from "../pages/admin/GerarLink";
import Conversas from "../pages/admin/Conversas";
import Dashboard from "../pages/admin/Dashboard";
import PixPendentes from "../pages/admin/PixPendentes";
import Funil from "../pages/admin/Funil";
import Campanhas from "../pages/admin/Campanhas";
import Marketing from "../pages/admin/Marketing";
import CheckoutPage from "../pages/checkout/page";
import CheckoutSucessoPage from "../pages/checkout/Sucesso";
import MusicaPage from "../pages/musica/page";
import AdminGate from "../components/AdminGate";
import LandingTemplate from "../pages/landing/LandingTemplate";
import landingPages from "../data/seo-pages";
import AcquisitionLandingPage from "../pages/acquisition/AcquisitionLandingPage";
import ExemplosPage from "../pages/exemplos/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/criar",
    element: <CriarPage />,
  },
  {
    path: "/criar-musica",
    element: <CriarMusicaPage />,
  },
  {
    path: "/criar-musica/letras/:slug",
    element: <CriarMusicaLyricsPage />,
  },
  {
    path: "/criar-musica/gravando/:slug",
    element: <CriarMusicaRecordingPage />,
  },
  {
    path: "/criar-musica/previa/:slug",
    element: <CriarMusicaPreviewPage />,
  },
  {
    path: "/criar-musica/pedido/:slug",
    element: <CriarMusicaOrderPage />,
  },
  {
    path: "/criar-musica/checkout/:slug",
    element: <CriarMusicaCheckoutPage />,
  },
  {
    path: "/criar-musica/sucesso/:slug",
    element: <CriarMusicaSuccessPage />,
  },
  {
    path: "/criar-musica/pedido/:slug/fotos",
    element: <CriarMusicaPhotosPage />,
  },
  {
    path: "/criar-musica-personalizada",
    element: <AcquisitionLandingPage />,
  },
  {
    path: "/exemplos",
    element: <ExemplosPage />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PrivacyPage />,
  },
  {
    path: "/exclusao-de-dados",
    element: <DataDeletionPage />,
  },
  {
    path: "/termos-de-servico",
    element: <TermsPage />,
  },
  {
    path: "/ouvir",
    element: <OuvirPage />,
  },
  {
    path: "/ouvir/:slug",
    element: <OuvirSlugPage />,
  },
  // Player da música completa em modo pré-venda: sem download, sem compartilhar,
  // sem editar capa. Pra leads com receio de pagar antes de ouvir a música inteira.
  {
    path: "/musica-completa/:slug",
    element: <OuvirSlugPage lockedPreview />,
  },
  {
    path: "/ouvir-musica/:slug",
    element: <CheckoutPage />,
  },
  {
    path: "/ouvir-musica/:slug/sucesso",
    element: <CheckoutSucessoPage />,
  },
  // Redesign novo (preview) — paralelo a /ouvir-musica/:slug
  {
    path: "/musica/:slug",
    element: <MusicaPage />,
  },
  {
    path: "/pagamento-realizado",
    element: <ObrigadoPage />,
  },
  {
    path: "/obrigado",
    element: <ObrigadoPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <PostPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/musica-personalizada",
    element: <MusicaPersonalizadaPage />,
  },
  {
    path: "/afiliados",
    element: <AfiliadosPage />,
  },
  {
    path: "/afiliados/portal",
    element: <AfiliadoPortalPage />,
  },
  {
    path: "/afiliados/termos",
    element: <AfiliadosTermosPage />,
  },
  {
    path: "/admin",
    element: (
      <AdminGate>
        <Dashboard />
      </AdminGate>
    ),
  },
  {
    path: "/admin/dashboard",
    element: (
      <AdminGate>
        <Dashboard />
      </AdminGate>
    ),
  },
  {
    path: "/admin/gerar-link",
    element: (
      <AdminGate requireFullAdmin>
        <GerarLink />
      </AdminGate>
    ),
  },
  {
    path: "/admin/conversas",
    element: (
      <AdminGate>
        <Conversas />
      </AdminGate>
    ),
  },
  {
    path: "/admin/pix-pendentes",
    element: (
      <AdminGate requireFullAdmin>
        <PixPendentes />
      </AdminGate>
    ),
  },
  {
    path: "/admin/funil",
    element: (
      <AdminGate>
        <Funil />
      </AdminGate>
    ),
  },
  {
    path: "/admin/campanhas",
    element: (
      <AdminGate>
        <Campanhas />
      </AdminGate>
    ),
  },
  {
    path: "/admin/marketing",
    element: (
      <AdminGate>
        <Marketing />
      </AdminGate>
    ),
  },

  // Landing pages programáticas — geradas dinamicamente a partir de seo-pages.ts
  // Cada slug do array gera uma rota estática para SEO previsível.
  ...landingPages.map((lp) => ({
    path: lp.path,
    element: <LandingTemplate slug={lp.slug} />,
  })),

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
